export const handleExceptionMessage = (
    error: any,
): { messageResponse: string; typeFeedback: 'error' | 'warn' } => {
    if (typeof error?.request?.response == 'string') {
        const response = JSON.parse(error.request.response);
        let typeFeedback: 'error' | 'warn' = 'error';
        if (response?.statusCode && [401, 403].includes(response.statusCode)) {
            typeFeedback = 'warn';
        }
        if (response.message) {
            return {
                messageResponse: response.message,
                typeFeedback,
            };
        }
    }
    return { messageResponse: '', typeFeedback: 'error' };
};
export const handleExceptionMultipleMessages = (error: any): string[] => {
    if (typeof error?.request?.response == 'string') {
        const response = JSON.parse(error.request.response);
        if (typeof response.message == 'string') {
            return [response.message];
        }
        if (typeof response.message != 'string') {
            return response.message;
        }
    }
    return [];
};
export const handleExceptionMessageApiNfe = (error: any): string[] => {
    if (typeof error?.request?.response == 'string') {
        const response = JSON.parse(error.request.response);
        if (typeof response.message == 'string') {
            return [response.message];
        }
        if (typeof response.message != 'string') {
            return response.message;
        }
    }
    return [];
};
